module.exports = __webpack_public_path__ + "img/delete.771c7b34.svg";